import { createHttpClient, type AppState } from '@eo/shared';

import { getRuntimeConfig } from './runtimeConfig';

export async function bootstrap(): Promise<Partial<AppState>> {
  const config = getRuntimeConfig();
  createHttpClient('api', config.apiUrl);
  return {
    appVersion: import.meta.env.VITE_APP_VERSION ?? 'dev',
    envVars: {
      apiUrl: config.apiUrl,
      auth0Domain: config.auth0Domain,
      auth0ClientId: config.auth0ClientId,
      auth0Audience: config.auth0Audience,
      publicBase: import.meta.env.VITE_PUBLIC_BASE ?? '/',
    },
    socketUrl: null,
  };
}
